import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from "styled-components";
import { ReactComponent as HighDemandIcon } from '../../assets/images/svg/high-demand-banner.svg';
import { mediaBelow } from '../../assets/styles/helper';
import { variables } from '../../assets/styles/variables';

const BannerWrapper = styled.div`
  display: flex;
  align-items: center;
  background: linear-gradient(90deg, #1D5AA7 0%, #0B3F7D 100%);
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-family: Arial, sans-serif;
  border-left: 6px solid #FFD700; 
  margin-top: 20px;
  margin-bottom: 20px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 2px;
`;

const Tag = styled.span`
  background-color: #FFD700;
  color: #104687;
  font-weight: bold;
  font-size: 0.75rem;
  padding: 3px 8px;
  border-radius: 20px;
  margin-right: 8px;
`;

const Title = styled.span`
  font-weight: bold;
  font-size: 18px;
  color: #fff;
   ${mediaBelow(variables.breakpoints.bpMd)} {
      font-size: 16px;
    }
`;

const Message = styled.span`
 font-size: 16px;
  color: #fff;
  opacity: 80%;
   ${mediaBelow(variables.breakpoints.bpMd)} {
      font-size: 14px;
    }
`;

const Year = styled.span`
  font-size: 16px;
  color: #FFD700;
  font-weight: 600;
  opacity: 80%;
  ${mediaBelow(variables.breakpoints.bpMd)} {
      font-size: 14px;
    }

`;

const MapleLeafBanner = () => {
  const { t } = useTranslation();

  return (
    <BannerWrapper>

      <HighDemandIcon style={{ borderRadius: '100%', marginRight: '20px' }} />
      <Content>
        <TitleRow>
          <Tag>{t('mapleLeafBanner.tag')}</Tag>
          <Title>{t('mapleLeafBanner.title')}</Title>
        </TitleRow>
        <Message>
          {t('mapleLeafBanner.message1')} <Year>{t('mapleLeafBanner.deliveryDate')}</Year>          {t('mapleLeafBanner.message2')}
        </Message>
      </Content>
    </BannerWrapper>
  );
};

export default MapleLeafBanner;
